import { defineStore } from "pinia"
// import { useUserStore } from "../stores/user"
// import { useAppStore } from "../stores/app"
// import Vue from 'vue'

// import {
//     HMSReactiveStore,
//     selectIsLocalAudioEnabled,
//     selectIsLocalVideoEnabled,
//     selectIsLocalScreenShared,
//     selectPeers,
//     selectIsConnectedToRoom,
//     selectLocalPeerRoleName,
//     selectLocalPeer,
//     selectIsInPreview,
//     selectDevices,
//     selectLocalMediaSettings,
//     selectIsLocalVideoPluginPresent,
//     selectIsPeerAudioEnabled,
//     selectIsPeerVideoEnabled,
//     selectHMSMessages,
//     selectScreenShareByPeerID
// } from "@100mslive/hms-video-store"
// import { setVirtualBackground, HMSVirtualBackgroundPlugin } from '@100mslive/hms-virtual-background'
// // Initialize HMS Store
// const hmsManager = new HMSReactiveStore()
// hmsManager.triggerOnSubscribe()
// const hmsStore = hmsManager.getStore()
// const hmsActions = hmsManager.getActions()
// const hmsNotifications = hmsManager.getNotifications()

// import { selectIsInPreview } from '@100mslive/hms-video-store'

// import { HMSReactiveStore } from "@100mslive/hms-video-store"
import { useAppStore } from "./app"

export const useMeetingStore = defineStore("meeting", {
    state: () => {
        return {
            user: null,
            app: null,
            peers: [],
            room_name: null,
            room: null,
            token: '',
            hmsActions: null,
            hmsStore: null,
            is_connected: false,
            sidebar_width: 300,
            participants_chat_switch: null,
            messages: [],
            local_peer: {},
            new_message_count: 0,
            peer_audio_enabled: {},
            peer_video_enabled: {},
            show_nav_drawer: false,
            local_audio_enabled: false,
            local_video_enabled: false,
            virtual_background: null,
            loading_video_plugin: false,
            toggle_blur: false,
            blur_on: false,
            toggle_screenshare: false,
            is_local_screen_shared: false,
            show_settings: false,
            leaving: false,
            isScreenSharingEnabled: false,
            is_recording: false,
            is_in_preview: false,
            permissions: null,
            cobrowse_session: {},
            recording_state: {},
            livestream_state: {
                running: false
            },
            is_whiteboard_active: false,
            whiteboard_code: "",
            wt: null,
            rtmp_starting: false,
            rtmp_stopping: false,
            presence_channel: {},
            lobby_presence_channel: {},
            refresh_lobby: null,
            // lobby_presence_channels: {},
            // lobby_presence_channel_0: {},
            // lobby_presence_channel_1: {},
            // lobby_presence_channel_2: {},
            // lobby_presence_channel_3: {},
            // lobby_presence_channel_4: {},
            // lobby_presence_channel_5: {},
            // lobby_presence_channel_6: {},
            // lobby_presence_channel_7: {},
            // lobby_presence_channel_8: {},
            // lobby_presence_channel_9: {},
            lobbies: 0,
            coach_hand_raised: false,
            video_playlist: [],
            audio_playlist: [],
            room_started: false,
            toggle_auto_record: false,
            recording_starting: false,
            session_id: null,
        }
    },
    actions: {
        leave: async function() {
            this.leaving = true
            if(this.local_peer.roleName == 'host') {
                var host_count = 0
                this.peers.forEach(peer => {
                    if(peer.roleName == 'host')
                        host_count++
                })
                if(host_count <= 1) {
                    try {
                        const lock = false; // set to true to disallow rejoins
                        const reason = 'Host left meeting';
                        await this.hmsActions.endRoom(lock, reason);
                    } catch (error) {
                        // Permission denied or not connected to room
                        console.error(error);
                    }
                }
            }
            if(this.hmsActions)
                return this.hmsActions.leave()

            //TODO: redirect to URL?

        },
        enablePeerAudio: async function(peer, enable) {
            try {
                if(peer.isLocal)
                    await this.hmsActions.setLocalAudioEnabled(!this.local_audio_enabled)
                else
                    await this.hmsActions.setRemoteTrackEnabled(peer.audioTrack, enable);
            } catch (error) {
                // Permission denied or invalid track ID or not connected to room
                console.error(error);
            }
        },
        enablePeerVideo: async function(peer, enable) {
            try {
                if(peer.isLocal)
                    await this.hmsActions.setLocalVideoEnabled(!this.local_video_enabled)
                else
                    await this.hmsActions.setRemoteTrackEnabled(peer.videoTrack, enable);
            } catch (error) {
                // Permission denied or invalid track ID or not connected to room
                console.error(error);
            }
        },
        muteAllGuests: async function() {
            try {
                const options = {
                    enabled: false, // false to mute, true to unmute
                    roles: ['guest'], // optional, array of roles to mute, mutes everyone if not passed
                    type: 'audio', // optional, audio/video, mutes both if not passed
                    source: 'regular' // optional, mutes all sources(regular, screen etc.) if not passed
                };
                await this.hmsActions.setRemoteTracksEnabled(options);
            } catch (error) {
                // Permission denied or invalid track ID or not connected to room
                console.error(error);
            }
        },
        isCobrowsing: function() {
            let is_cobrowsing = this.cobrowse_session?.session_id ?? false
            return is_cobrowsing
        },
        isRecording: function() {
            return this.recordingPeers().length > 0
            // return this.is_recording
            // return this.recording_state?.browser?.running
        },
        recordingPeers: function() {
            return this.peers.filter(peer => peer.roleName && peer.roleName.indexOf('record') > -1)
        },
        startRecording: async function(params) {
            // import the app store
            this.app = useAppStore()

            this.recording_starting = true

            let recording_domain = this.app.site?.domain_settings?.settings?.domain?.meta?.recording_domain[0] 
                ? this.app.site.domain_settings.settings.domain.meta.recording_domain[0] 
                : window.location.hostname
            let meetingUrl = 'https://'+recording_domain+window.location.pathname+"#/record-guest"
            
            const data = {
                meetingURL: meetingUrl,
                resolution: { width: 720, height: 480 },
                record: true,
                postbackURL: this.app.api.url+'meeting/webhook',
                session_id: this.session_id,
                location_id: params.l ?? '',
                contact_id: params.c ?? '',
            }

            if(this.app.site?.domain_settings?.settings?.domain?.meta?.recording_service == 'recordit') {
                this.startRecordIt(data)
            } else {
                this.startRecording100Ms(data)
            }
        },
        startRecordIt(params) {
            let g = this
            this.app.post(`meeting/recordit/${this.app.room_id}`, params)
                .then(response => {
                    console.log("recordit", response)
                    if(response.data?.error) {
                        // this.app.showError(response.data.error)
                        // this.recording_starting = false
                        console.log("Problem with recordit, try 100ms")
                        g.startRecording100Ms(params)
                    } else {
                        // all good
                        this.app.showNotification(response.data.success)
                        this.recording_starting = false
                    }
                })
                .catch(error => {
                    // this.app.showError(error?.message)
                    // this.recording_starting = false
                    console.log("Other Recordit Error", error)
                    g.startRecording100Ms(params)
                })
        },
        startRecording100Ms: async function(params) {
            console.log("startRecording100Ms")
            await this.hmsActions.startRTMPOrRecording(params)
        },
        stopRecording100Ms: async function() {
            console.log("stopRecording100Ms")
            await this.meeting.hmsActions.stopRTMPAndRecording()
        },
        stopRecording: async function() {

            this.stopRecording100Ms()
            return

            // temporary defaulting to 100ms recording for now
            // the below code is supposed to handle stopping 100ms or azure based recording but it sometimes doesn't stop 100ms recording
            // TODO: fix the below code to make sure 100ms recording is stopped.

            console.log("stop the recording!")
            if (this.recording_state?.browser?.running) {
                return this.stopRecording100Ms()
            }
            this.recording_starting = true
            //if this peer is the record peer, then stop recording and leave the meeting
            if(this.local_peer.roleName.indexOf('record') > -1) {
                // we stop the recording by logging to the console STOP_RECORDING
				// which is what the RecordIt.online meeting peer watches for
                console.log('STOP_RECORDING')
                this.hmsActions.leave()
            } else {
                // else, if this is a host, coach, then send the stop recording notification to
                // all recording peers
                let recording_peers = this.recordingPeers()
                recording_peers.forEach(async peer => {
                    //send the recording peer the command to stop recording
                    await this.hmsActions.sendDirectMessage('STOP_RECORDING', peer.id, 'STOP_RECORDING');
                    // this.removePeerByPeerId(peer.id)
                })
            }
        },
        removePeerByPeerId: function(peer_id) {
            const reason = 'Good Bye'
            this.hmsActions.removePeer(peer_id, reason)
        },
        isLivestreaming: function() {
            return this.livestream_state?.running
        },
        activateWhiteboard() {
            const g = this
            setTimeout(function(){
                console.log("activating whiteboard:", g.whiteboard_code)
                this.wt = new api.WhiteboardTeam('#wt-container', {
                    clientId: '71ea8f93998f65b689b1ad39ed996882',
                    boardCode: g.whiteboard_code,
                    participant: {
                        role : g.local_peer.roleName == 'host' ? 'editor' : 'viewer',
                        name : g.local_peer.name
                    },
                    board: {
                        bg: 'None'
                    }
                });
            }, 200)
		}
        // getPermissions: function() {
        //     const permissions = hsmStore.getState(selectPermissions);
        //     return permissions
        // }
        // isInPreview: function() {
        //     // return true 
        //     const is_in_preview = hmsStore.getState(selectIsInPreview)
        //     console.log("is_in_preview", is_in_preview)
		// 	return is_in_preview
		// }
    }
})